import React from 'react';
import styles from './EditInvoice.module.scss';

const EditInvoice: React.FC = () => {
  return (
    <div className={styles.editInvoice}>
      <h1>Edit Invoice</h1>
      <p>Invoice editing form will be implemented here.</p>
    </div>
  );
};

export default EditInvoice; 